import {
  Button,
  buttonVariants,
  Spinner,
  useToast,
} from '@barfacil/barfacil-ui'
import { VariantProps } from 'class-variance-authority'
import { ImagePlus, X } from 'lucide-react'
import { forwardRef } from 'react'

import { Image } from '@/api/_schemas/management'
import {
  handleInputChange,
  InputFile,
  UpdateImage,
} from '@/app/panel/management/price-list/_components/input-file'
import { cn } from '@/lib/utils'

interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
  isLoading?: boolean
}

type ImportImageProps = {
  id?: number
  currentImage: Image | null
  removeCurrentImage: () => void
  callbackFn: (props: UpdateImage) => void
  isLoading: boolean
  setIsLoading: (value: boolean) => void
}

export const AddImageButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => {
    return (
      <Button
        variant="ghost"
        className={cn(
          'grid size-16 place-items-center text-wrap rounded bg-sky-25 p-2 text-center text-[8px] leading-none text-sky-500 hover:bg-sky-50 active:bg-sky-100',
          className,
        )}
        ref={ref}
        {...props}
      >
        <ImagePlus size={16} />
        <span>ADICIONAR IMAGEM</span>
      </Button>
    )
  },
)

export const ImportImage = ({
  id,
  currentImage,
  removeCurrentImage,
  callbackFn,
  isLoading,
  setIsLoading,
}: ImportImageProps) => {
  const { toastDestructive } = useToast()

  if (currentImage) {
    return (
      <div className="relative size-16">
        <img
          className="aspect-square size-16 rounded border border-sky-25"
          src={currentImage.imagem_path}
          alt="Imagem de descrição do produto"
        />

        <button
          className="absolute -right-2 -top-2 grid size-4 place-content-center rounded-full bg-gray-500 transition-transform duration-300 hover:scale-110 hover:bg-gray-400 active:bg-gray-700"
          onClick={removeCurrentImage}
        >
          <X className="text-white" size={12} />
        </button>
      </div>
    )
  }

  return (
    <Button
      variant="ghost"
      className={cn(
        'grid size-16 place-items-center text-wrap rounded bg-sky-25 p-2 text-[8px] leading-none text-sky-500',
        id
          ? 'hover:bg-sky-50 active:bg-sky-100'
          : 'pointer-events-none hover:bg-sky-25',
      )}
    >
      <label
        className="grid cursor-pointer place-items-center gap-1"
        htmlFor="upload"
      >
        {isLoading ? (
          <Spinner className="size-5" />
        ) : (
          <>
            <ImagePlus size={16} />
            ADICIONAR IMAGEM
          </>
        )}
      </label>

      <InputFile
        id="upload"
        disabled={!id}
        onChange={(e) =>
          handleInputChange(e, {
            setIsLoading,
            callbackFn,
            callbackErrorFn: toastDestructive,
            id: id as number,
          })
        }
      />
    </Button>
  )
}

AddImageButton.displayName = 'AddImageButton'
